var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplyChainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.33325L28.6667 8.66658V23.3333L16 30.6666L3.33334 23.3333V8.66658L16 1.33325ZM7.32518 9.43685L16.0001 14.4591L24.6749 9.4369L16 4.41459L7.32518 9.43685ZM6.00001 11.751V21.7958L14.6668 26.8134V16.7686L6.00001 11.751ZM17.3335 26.8133L26 21.7958V11.7511L17.3335 16.7686V26.8133Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyChainIcon);
export default __webpack_public_path__ + "static/media/supply-chain-icon.82106915279cee676382791e54e333bd.svg";
export { ForwardRef as ReactComponent };